import WidgetError from './WidgetError';
export default class RequestCancelledError extends WidgetError {
    static code = 'REQUEST-CANCELED';
    constructor(message) {
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, RequestCancelledError.prototype);
        this.name = this.getCode();
    }
}
//# sourceMappingURL=RequestCancelledError.js.map